import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../slices/store";
import {
  editUser,
  getSingleUser,
  saveUser,
  uploadFileResource,
  getUserRequests,
  getUserNotRequests,
} from "../../slices/users/userManagementSlice";
import {
  ComponentType,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IUser } from "./models/User";

import { TodosContext } from "../../context";
import { scrollToTop } from "../../utils/helpers/helperMethods/scrollToTop";
import UseAuthConfig from "../../hooks/useAuthConfig";

export function withUserManagementControllerWrapper<T>(
  Component: ComponentType<T>
) {
  return (hocProps: Omit<T, "userdata">) => {
    const { alert, addAlert } = useContext(TodosContext);
    const { protectedResources }: any = UseAuthConfig();
    let location = useLocation();
    let navigate = useNavigate();
    let userStatusData: any;
    let userTypesData: any;
    const dispatch = useDispatch<AppDispatch>();
    const status = useSelector(
      (state: RootState) => state.userManagement.status
    );
    let loggedUser: any = "";
    loggedUser = window.localStorage.getItem("user");
    let bearerToken = `Bearer ${window.localStorage.getItem("token")}`;
    userTypesData = window.localStorage.getItem("userTypes");
    userTypesData = JSON.parse(userTypesData);
    userStatusData = window.localStorage.getItem("userStatus");
    userStatusData = JSON.parse(userStatusData);
    const [selectedUser, setSelectedUser] = React.useState();
    const [filteredValue, setFilteredValue] = React.useState();
    const [clickFilterStatus, setClickFilterStatus] = React.useState(false);
    const [clickFilterSearch, setClickFilterSearch] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [usersRequests, setUsersRequest] = React.useState({
      PageNumber: 1,
      SearchText: "",
      SortOrder: 1,
      PageSize: 12,
      OrderBy: "JobTitle",
      url: protectedResources.apiTodoList.endpoint,
      accessToken: localStorage.getItem("AccessToken") || "llll",
    });
    const activePageInLocalUsers = localStorage.getItem("usersActivePage");
    const activePageInLocalRequests = localStorage.getItem("requestActivePage");
    let getUserParams = {
      fromStatus: 0,
      toStatus: 2,
      token: bearerToken,
    };

    let loggedUserParams = {
      username: loggedUser,
      token: bearerToken,
    };

    const handleSetFilteredValue = (inputValue: string) => {
      setClickFilterStatus(false);
      setClickFilterSearch(true);
    };

    const handleSetFilterByStatus = (data: any) => {
      setClickFilterStatus(true);
      setClickFilterSearch(false);
      if (data === "All") {
        // dispatch(user(getUserParams));
      } else {
        getUserParams = {
          fromStatus: parseInt(data),
          toStatus: parseInt(data),
          token: bearerToken,
        };
        // dispatch(user(getUserParams));
      }
    };

    const createUser = async (userData: IUser, selectedFile: any) => {
      scrollToTop();
      setIsLoading(true);
      let userParams = {
        user: userData,
        accessToken: localStorage.getItem("AccessToken") || "",
        loggedUser: loggedUser,
        imageURL: "",
        url: protectedResources.apiTodoList.endpoint,
      };
      dispatch(saveUser(userParams)).then((r: any) => {
        if (r.payload?.status === "success") {
          setIsLoading(false);
          addAlert("User Created Successfully", "success", true);
          // dispatch(user(getUserParams));
          navigate("/user/users");
        } else {
          setIsLoading(false);
          addAlert("User Created Failed", "failed", true);
          navigate("/user/users");
        }
      });
    };

    const handleEditUser = (userData: IUser, selectedFile: any) => {
      let userParams;
      const locations: any = location.pathname.split("/")[2];
      if (locations === "users") {
        userParams = {
          user: userData,
          accessToken: localStorage.getItem("AccessToken") || "",
          // "loggedUser":loggedUser,
          //   imageURL: "",
          url:
            protectedResources.apiTodoList.endpoint + `/users/${userData.id}`,
          selectedFile: selectedFile,
        };
        // dispatch(editUser(userParams))
        //   .then((r) => {
        //     if (r.payload) {
        //       if (status === "idle") {
        //         addAlert("User Updated Successfully", "success", true);
        //         let routePath: any = localStorage.getItem("userLocation");
        //         navigate(routePath.toString());
        //         localStorage.setItem(
        //           "previousLocation",
        //           "/user/users/view-profile/:id"
        //         );

        //         const params = {
        //           ...usersRequests,
        //           PageNumber: activePageInLocalUsers
        //             ? parseInt(activePageInLocalUsers, 10)
        //             : 1,
        //           ParameterOne: "Approved",
        //           ParameterTwo: "Administrator,Operator",
        //           ParameterThree: "Active,Pending,Inactive",
        //         };
        //         dispatch(getUserNotRequests(params));
        //       }
        //     } else {
        //       addAlert("User Updated Failed", "failed", true);
        //       navigate("/user/users");
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
      } else {
        userParams = {
          user: userData,
          accessToken: localStorage.getItem("AccessToken") || "",
          // "loggedUser":loggedUser,
          // "imageURL":"",
          url:
            protectedResources.apiTodoList.endpoint +
            `/accounts/${userData.id}`,
          selectedFile: selectedFile,
        };
        // dispatch(editUser(userParams))
        //   .then((r) => {
        //     if (r.payload) {
        //       if (status === "idle") {
        //         addAlert("User Updated Successfully", "success", true);
        //         let routePath: any = localStorage.getItem("userLocation");
        //         navigate(routePath.toString());
        //         localStorage.setItem(
        //           "previousLocation",
        //           "/user/requests/view-profile/:id"
        //         );
        //       }
        //     } else {
        //       addAlert("User Updated Failed", "failed", true);
        //       navigate("/user/requests");
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
      }
    };

    const handleDeleteUser = (userData: IUser) => {
      axios.delete(`http://localhost:3000/users/` + userData.id).then((res) => {
        // dispatch(user(getUserParams));
        navigate("/user");
      });
    };
    return (
      <Component
        {...(hocProps as T)}
        // userdata={userData}
        selectedUser={selectedUser}
        handleEditUser={handleEditUser}
        handleDeleteUser={handleDeleteUser}
        createUser={createUser}
        loggedUser={loggedUser}
        userTypesData={userTypesData}
        userStatusData={userStatusData}
        status={status}
        handleSetFilteredValue={handleSetFilteredValue}
        handleSetFilterByStatus={handleSetFilterByStatus}
        filteredValue={filteredValue}
        clickFilterStatus={clickFilterStatus}
        clickFilterSearch={clickFilterSearch}
        isLoading={isLoading}
      />
    );
  };
}
